import type { ClassificationType } from "@/types/entity";
import type { RiskLevel } from "@/components/ui/risk-level-badge/RiskLevelBadge";

export type ClassificationVariant = ClassificationType | "UNCLASSIFIED";

export const CLASSIFICATION_NAMES: Record<ClassificationVariant, string> = {
  ESSENTIAL: "Esențială",
  IMPORTANT: "Importantă",
  OUT_OF_SCOPE: "În afara scopului",
  IMPACT: "Necesită analiză efect perturbator",
  UNCLASSIFIED: "Neclasificată",
};

export const CLASSIFICATION_EXPLANATIONS: Record<
  ClassificationVariant,
  string
> = {
  ESSENTIAL:
    "Entitate Esențială: organizație de importanță critică pentru sectoarele NIS2, cu obligații sporite de raportare și conformitate.",
  IMPORTANT:
    "Entitate Importantă: organizație din sectoarele NIS2 cu obligații standard de notificare și management al riscurilor.",
  OUT_OF_SCOPE:
    "În afara scopului: entitatea nu intră sub incidența cerințelor NIS2 conform criteriilor de sector și dimensiune.",
  IMPACT:
    "Necesită analiză efect perturbator: clasificarea finală depinde de o evaluare suplimentară a impactului serviciilor furnizate.",
  UNCLASSIFIED:
    "Neclasificată: nu s-a determinat încă încadrarea NIS2 — completați etapa de identificare pentru a obține clasificarea.",
};

export const RISK_NAMES: Record<RiskLevel, string> = {
  DE_BAZA: "de Bază",
  IMPORTANT: "Important",
  ESENTIAL: "Esențial",
  NEEVALUAT: "Neevaluat",
};

export const RISK_EXPLANATIONS: Record<RiskLevel, string> = {
  DE_BAZA:
    "Risc de Bază: profil de risc redus — controale de bază sunt suficiente pentru îndeplinirea cerințelor NIS2.",
  IMPORTANT:
    "Risc Important: profil de risc moderat — necesită controale suplimentare și monitorizare activă.",
  ESENTIAL:
    "Risc Esențial: profil de risc ridicat — necesită controale avansate, audituri periodice și raportare extinsă.",
  NEEVALUAT:
    "Neevaluat: nivelul de risc nu a fost încă determinat — finalizați evaluarea de risc pentru a obține un rezultat.",
};
